module.exports = __webpack_public_path__ + "img/sp.16ea655a.png";